import { render, staticRenderFns } from "./dianshang.vue?vue&type=template&id=91d388de&scoped=true"
import script from "./dianshang.vue?vue&type=script&lang=js"
export * from "./dianshang.vue?vue&type=script&lang=js"
import style0 from "./dianshang.vue?vue&type=style&index=0&id=91d388de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d388de",
  null
  
)

export default component.exports